import { Step1FormOptionsProps, Step1FormProps } from '../types'
import { useContractsQuery } from '../../../../api/options/hooks'
import { PersonAuthorisationTypesList } from '../constants'

const useStep1FormOptions = (form: Step1FormProps['form']): Step1FormOptionsProps => {
    const { data, error, isLoading } = useContractsQuery()

    return {
        permissions: PersonAuthorisationTypesList,
        contracts: {
            data,
            error,
            isLoading,
        },
    }
}

export default useStep1FormOptions
